import { render, staticRenderFns } from "./PopoverRejectedReasons.vue?vue&type=template&id=5f916b48&scoped=true"
import script from "./PopoverRejectedReasons.vue?vue&type=script&lang=js"
export * from "./PopoverRejectedReasons.vue?vue&type=script&lang=js"
import style0 from "./PopoverRejectedReasons.vue?vue&type=style&index=0&id=5f916b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f916b48",
  null
  
)

export default component.exports